import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { IMediaElement } from '../components/types'
import { useQuery } from '@apollo/client'
import {
  reviewsFiles,
  reviewsFilesVariables,
} from '../__generated__/reviewsFiles'
import { REVIEWS_FILES } from '../queries/reviewQuery'
import createMediaElements from '../lib/createMediaElements'
import { ElementWhereInput } from '../__generated__/globalTypes'

interface IMediaSliderContext {
  slides: IMediaElement[]
  loading: boolean
  isEnd: boolean
  setIsEnd: Dispatch<SetStateAction<boolean>>
}

export const MediaSliderContext = createContext({} as IMediaSliderContext)

const MediaSliderProvider: FC<{ productId?: string }> = ({
  children,
  productId,
}) => {
  const vars: ElementWhereInput = {
    iblock: { bx_id: { equals: 6 } },
    active: { equals: true },
  }

  if (productId) {
    vars.propertyValuesRelation = {
      some: {
        property: { code: { equals: 'ELEMENT' } },
        targetElement: {
          active: { equals: true },
          iblock: { bx_id: { equals: 42 } },
          id: { equals: productId },
        },
      },
    }
  }
  const { data, fetchMore, loading } = useQuery<
    reviewsFiles,
    reviewsFilesVariables
  >(REVIEWS_FILES, { variables: { element: vars } })

  const slides = useMemo(() => createMediaElements(data?.files || []), [data])

  const [isEnd, setIsEnd] = useState(false)

  useEffect(() => {
    if (isEnd) {
      loadMore()
    }
  }, [isEnd])

  async function loadMore() {
    const cursor = slides?.[slides.length - 1]?.id

    if (!cursor) {
      return null
    }

    const res = await fetchMore({
      variables: { after: { id: cursor } },
    })

    if (!res?.data?.files?.length) {
      setIsEnd(true)
    } else {
      setIsEnd(false)
    }
  }

  return (
    <MediaSliderContext.Provider
      value={{
        loading: !data && loading,
        slides,
        isEnd,
        setIsEnd,
      }}
    >
      {children}
    </MediaSliderContext.Provider>
  )
}

export default MediaSliderProvider
